import {AxiosError} from 'axios'

import {useRefraQuery} from '@refra/modules/common/hooks'
import {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

interface useStaticPartReplacementQueryParams {
  plantUpmId: string
  kilnUpmId: string
  shutdownId: number
  componentId: number
  enabled?: boolean
}

export const useStaticPartReplacementQuery = ({
  plantUpmId,
  kilnUpmId,
  shutdownId,
  componentId,
  enabled = true
}: useStaticPartReplacementQueryParams) => {
  return useRefraQuery({
    queryKey: 'staticPartReplacement',
    params: [{plantUpmId, kilnUpmId, shutdownId, componentId}],
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data.detail ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('staticPartReplacement')
        .extras({errorDetails, plantUpmId, kilnUpmId})
        .error('Error occurred while fetching static part replacement detail')

      return false
    },
    enabled
  })
}
